const hexList: string[] = [];
for (let i = 0; i <= 15; i++) {
  hexList[i] = i.toString(16);
}

const UUID_TEMPLATE = [8, 13, 18, 23];

export function buildUUID(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  let uuid = '';
  let lastIndex = 0;

  for (const dashIndex of UUID_TEMPLATE) {
    for (let i = lastIndex; i < dashIndex; i++) {
      uuid += hexList[(Math.random() * 16) | 0];
    }
    uuid += '-';
    lastIndex = dashIndex;
  }

  for (let i = lastIndex; i < 36; i++) {
    if (i === 15) {
      uuid += '4';
    } else if (i === 20) {
      uuid += hexList[((Math.random() * 4) | 0) + 8];
    } else {
      uuid += hexList[(Math.random() * 16) | 0];
    }
  }
  return uuid.replace(/-/g, '');
}

let unique = 0;
export function buildShortUUID(prefix = ''): string {
  const time = typeof performance !== 'undefined' ? performance.now() : Date.now();
  const random = Math.floor(Math.random() * 1000000000);
  unique++;

  return prefix + '_' + random.toString(36) + unique.toString(36) + Math.floor(time).toString(36);
}
